import { Attribute, Bucket, MapLayer } from "@cartographerio/atlas-map";
import { Feature } from "@cartographerio/geometry";
import React, { ReactElement } from "react";
import DistributionChart from "./DistributionChart";
import FeaturesSelectedCount from "./FeaturesSelectedCount";
import InspectorBox from "./InspectorBox";
import InspectorHeading from "./InspectorHeading";
import InspectorItem from "./InspectorItem";
import InspectorTitle from "./InspectorTitle";
import Legend from "./Legend";
import TimelineChart from "./TimelineChart";

export interface AttributeInspectorProps {
  layer: MapLayer;
  attribute: Attribute;
  buckets: Bucket[];
  onBackClick: () => void;
  selectedFeatures: Feature[];
  onClearFeatureSelection: () => void;
}

export default function AttributeInspector(
  props: AttributeInspectorProps
): ReactElement {
  const {
    layer,
    attribute,
    buckets,
    onBackClick,
    selectedFeatures,
    onClearFeatureSelection,
  } = props;

  const timelineChart = selectedFeatures.length > 0 &&
    attribute.type !== "SimpleAttribute" &&
    attribute.propertyType === "number" &&
    attribute.showTimelineChart && (
      <TimelineChart attribute={attribute} features={selectedFeatures} />
    );

  const distributionChart = attribute.type !== "SimpleAttribute" &&
    attribute.showDistributionChart && (
      <DistributionChart
        attribute={attribute}
        buckets={buckets}
        features={selectedFeatures}
      />
    );

  return (
    <InspectorBox>
      <InspectorTitle backLabel="Back to layer menu" onBackClick={onBackClick}>
        Attribute
      </InspectorTitle>

      <FeaturesSelectedCount
        count={selectedFeatures.length}
        onClear={onClearFeatureSelection}
      />

      <InspectorHeading>Name</InspectorHeading>

      <InspectorItem>{attribute.label}</InspectorItem>

      {timelineChart}

      {distributionChart}

      <InspectorHeading>Legend</InspectorHeading>

      <Legend layerType={layer.type} attribute={attribute} buckets={buckets} />
    </InspectorBox>
  );
}
